import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TemplateHoverAndSelectAllEditing from './templatehoverandselectallediting';
import TemplateHoverAndSelectAllCommand from './templatehoverandselectallcommand';
export default class TemplateHoverAndSelectAll extends Plugin {
  static get requires() {
    return [ TemplateHoverAndSelectAllEditing, TemplateHoverAndSelectAllCommand ];
  }

  static get pluginName() {
    return 'TemplateHoverAndSelectAll';
  }
}
